import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ba1ad0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questionnaire-show" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "問診票", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "notice" }, [
  /*#__PURE__*/_createTextVNode(" 問診票のご記入ありがとうございます"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" スタッフにこの画面をご提示ください ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-horizontal" }, null, -1))
const _hoisted_6 = { class: "tour" }
const _hoisted_7 = { class: "date" }
const _hoisted_8 = { class: "day-location" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-horizontal" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "お名前 [必須]", -1))
const _hoisted_11 = { class: "content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "体調について [必須]", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "content" }, "確認済み", -1))
const _hoisted_14 = { class: "container-buttons" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 再登録する ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 閉じる ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeaderWithCloseButton = _resolveComponent("TheHeaderWithCloseButton")!
  const _component_AppButtonPrimary = _resolveComponent("AppButtonPrimary")!
  const _component_AppButtonSecondary = _resolveComponent("AppButtonSecondary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheHeaderWithCloseButton, { onClose: _ctx.close }, null, 8, ["onClose"]),
    (_ctx.showScreen && _ctx.todayTour)
      ? (_openBlock(), _createElementBlock("main", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.todayTour.dateString), 1),
            _createElementVNode("div", _hoisted_8, " (" + _toDisplayString(_ctx.todayTour.dayOfTheWeek) + _toDisplayString(_ctx.todayTour.isHoliday ? '･祝' : '') + ") / " + _toDisplayString(_ctx.todayTour.location), 1)
          ]),
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.questionnaire.name), 1),
          _hoisted_12,
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_AppButtonPrimary, {
              class: "primary",
              "show-caret": false,
              onButton: _ctx.toQuestionnaireFillOut
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["onButton"]),
            _createVNode(_component_AppButtonSecondary, {
              class: "secondary",
              onButton: _ctx.close
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["onButton"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}